import { API_PAGE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useAPIPage() {
  return useIsFeatureEnabled(API_PAGE);
}
